import {
LuSparkles,
LuTarget,
LuRocket,
LuCode,
LuUsers,
LuGithub
} from "react-icons/lu"
import { useState,useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./About.css"

function About(){

const [loaded,setLoaded]=useState(false)
const [imageLoaded,setImageLoaded]=useState(false)

const location = useLocation()

useEffect(()=>{

window.scrollTo(0,0)

setLoaded(false)

const timer=setTimeout(()=>{
setLoaded(true)
},100)

return()=>clearTimeout(timer)

},[location.pathname])

return(

<section className={`about ${loaded?"loaded":""}`}>

<div className="about-left">

<h1>
About <span>SLUZ</span>
</h1>

<div className="about-dotted">
<p>
SLUZ is a structured career roadmap platform designed to give students a clear direction toward skills, internships and placements. Instead of random learning, students follow a focused step-by-step path built using real industry expectations.
</p>
</div>

<div className="about-cards">

<div className="about-card">
<LuTarget className="about-icon green"/>
<h3>Vision</h3>
<p>Remove career confusion and provide clear structured guidance.</p>
</div>

<div className="about-card">
<LuRocket className="about-icon blue"/>
<h3>Mission</h3>
<p>Help students build skills, projects and internship strategies.</p>
</div>

<div className="about-card">
<LuCode className="about-icon orange"/>
<h3>Technology</h3>
<p>Built with modern web technologies and scalable architecture.</p>
</div>

<div className="about-card">
<LuUsers className="about-icon purple"/>
<h3>Student First</h3>
<p>Every feature is designed specifically for student success.</p>
</div>

</div>

<div className="developer-panel">

<h3>
<LuSparkles className="panel-icon"/> Developer
</h3>

<p>
Built with focus and vision by <strong>Sanket Padhyal</strong>
</p>

<a
href="https://github.com/sanketpadhyal"
target="_blank"
rel="noreferrer"
className="github-btn"
>
<LuGithub/> GitHub Profile
</a>

</div>

<div className="contributor-panel">

<h3>
<LuUsers className="panel-icon"/> Contributors
</h3>

<div className="contributor">

<LuGithub className="contributor-icon"/>

<div>
<h4>Sanket Padhyal</h4>
<p>Creator & Maintainer</p>
</div>

</div>

</div>

</div>

<div className="about-right">

<div className="about-image-wrapper">

{!imageLoaded && <div className="about-skeleton"></div>}

<img
src="/assets/about2.png"
alt="about sluz"
className={`about-image ${imageLoaded?"show":"hide"}`}
onLoad={()=>setImageLoaded(true)}
draggable="false"
/>

</div>

</div>

</section>

)

}

export default About